import { render, staticRenderFns } from "./Events_wrap.vue?vue&type=template&id=7042b59a"
import script from "./Events_wrap.vue?vue&type=script&lang=js"
export * from "./Events_wrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports